<template>
  <div class="image-management">
    <!-- 标题 -->
    <div class="page-header">
      <div class="header-left">
        <h2>图片管理</h2>
      </div>
      <div class="header-right">
        <router-link to="/pics" class="btn-primary">用户头像</router-link>
        <router-link to="/userdeshespic" class="btn-primary"
          >用户菜品图片</router-link
        >
      </div>
    </div>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-row">
        <div class="filter-item">
          <label>状态：</label>
          <select v-model="filters.status" @change="handleSearch">
            <option value="">全部</option>
            <option value="pending">待检测</option>
            <option value="safe">安全</option>
            <option value="violation">违规</option>
            <option value="review">疑似</option>
            <option value="failed">失败</option>
          </select>
        </div>

        <div class="filter-item">
          <label>图片类型：</label>
          <select v-model="filters.image_type" @change="handleSearch">
            <option value="">全部</option>
            <option value="avatar">头像</option>
            <option value="background">背景图</option>
            <option value="dish">菜品</option>
            <option value="daka_dish_image">打卡</option>
          </select>
        </div>

        <div class="filter-item">
          <label>删除状态：</label>
          <select v-model="filters.is_deleted" @change="handleSearch">
            <option value="">全部</option>
            <option value="0">正常</option>
            <option value="1">已删除</option>
          </select>
        </div>

        <div class="filter-item">
          <label>关键词：</label>
          <input
            type="text"
            v-model="filters.keyword"
            placeholder="搜索OpenID或图片URL"
            @keyup.enter="handleSearch"
          />
        </div>

        <div class="filter-actions">
          <button class="btn-primary" @click="handleSearch">查询</button>
          <button class="btn-default" @click="handleReset">重置</button>
        </div>

<!-- <div>
  <button class="upload-trigger-btn" @click="openModal">
    <span class="btn-icon">📷</span> 上传图片
  </button>
</div> -->


        <div class="alldel">
          <button class="btn-danger" @click="handleDeleteAllDeleted">
            清空全部已删除
          </button>
        </div>
      </div>
    </div>

    <!-- 表格列表 -->
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>图片</th>
            <th>图片类型</th>
            <th>状态</th>
            <th>检测结果</th>
            <th>违规类型</th>
            <th>删除状态</th>
            <th>用户OpenID</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in imageList" :key="item.id">
            <td>{{ item.id }}</td>
            <td>
              <div class="image-cell">
                <img
                  :src="item.image_url"
                  class="thumbnail"
                  @click="viewOriginalImage(item.image_url)"
                  title="点击查看原图"
                />
              </div>
            </td>
            <td>
              <span :class="['type-badge', getTypeClass(item.image_type)]">
                {{ getTypeName(item.image_type) }}
              </span>
            </td>
            <td>
              <span :class="['status-badge', getStatusClass(item.status)]">
                {{ getStatusName(item.status) }}
              </span>
            </td>
            <td>{{ item.suggest || "-" }}</td>
            <td>
              <span v-if="item.label" class="label-text">{{
                getLabelName(item.label)
              }}</span>
              <span v-else>-</span>
            </td>
            <td>
              <span
                :class="[
                  'delete-badge',
                  item.is_deleted === 1 ? 'deleted' : 'normal',
                ]"
              >
                {{ item.is_deleted === 1 ? "已删除" : "正常" }}
              </span>
            </td>
            <td class="openid-cell" :title="item.openid">{{ item.openid }}</td>
            <td>{{ formatDate(item.created_at) }}</td>
            <td>
              <button
                class="copy-link-btn"
                @click="copyImageUrl(item.image_url)"
              >
                复制链接
              </button>
              <button class="delete-btn" @click="handleDeleteImage(item)">
                删除
              </button>
            </td>
          </tr>
          <tr v-if="!loading && imageList.length === 0">
            <td colspan="11" class="empty-row">暂无数据</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 分页 -->
    <div class="pagination" v-if="total > 0">
      <div class="pagination-info">
        共 {{ total }} 条，每页
        <select v-model="pageSize" @change="handleSizeChange">
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>
        条
      </div>
      <div class="pagination-buttons">
        <button :disabled="page === 1" @click="handleCurrentChange(1)">
          首页
        </button>
        <button :disabled="page === 1" @click="handleCurrentChange(page - 1)">
          上一页
        </button>
        <span class="page-info">第 {{ page }} / {{ totalPages }} 页</span>
        <button
          :disabled="page === totalPages"
          @click="handleCurrentChange(page + 1)"
        >
          下一页
        </button>
        <button
          :disabled="page === totalPages"
          @click="handleCurrentChange(totalPages)"
        >
          末页
        </button>
      </div>
    </div>

    <!-- 复制成功提示 -->
    <div v-if="copySuccess" class="copy-toast">{{ copyMessage }}</div>

    <!-- 删除确认弹窗 -->
    <div
      v-if="deleteConfirmVisible"
      class="modal-mask"
      @click.self="closeDeleteConfirm"
    >
      <div class="modal-container">
        <div class="modal-header">
          <h3>确认删除</h3>
          <button class="close-btn" @click="closeDeleteConfirm">×</button>
        </div>
        <div class="modal-body">
          <p>确定要删除这张图片吗？</p>
          <p class="delete-warning">⚠️ 此操作将：</p>
          <ul class="delete-list">
            <li>删除 OSS 上的图片文件</li>
            <li>删除数据库中的检测记录</li>
            <li>如果是打卡图片，会清空对应的 custom_image 字段</li>
          </ul>
          <p class="delete-confirm-text">此操作不可恢复！</p>
        </div>
        <div class="modal-footer">
          <button class="btn-default" @click="closeDeleteConfirm">取消</button>
          <button class="btn-danger" @click="confirmDelete">确认删除</button>
        </div>
      </div>
    </div>
        <!-- 上传图片弹框 -->
    <div v-if="uploadModalVisible" class="modal-mask" @click.self="closeUploadModal">
      <div class="modal-container" style="width: 500px;">
        <div class="modal-header">
          <h3>📷 上传图片</h3>
          <button class="close-btn" @click="closeUploadModal">×</button>
        </div>
        
        <div class="modal-body">
          <!-- 隐藏的文件输入框 -->
          <input
            type="file"
            ref="fileInput"
            @change="handleFileChange"
            accept="image/jpeg,image/png,image/gif,image/webp"
            style="display: none"
          />
          
          <!-- 上传区域 -->
          <div class="upload-area" @click="triggerFileInput">
            <div v-if="!uploadPreview" class="upload-placeholder">
              <div class="upload-icon">📸</div>
              <p>点击选择图片</p>
              <span class="upload-hint">支持 JPG、PNG、GIF、WEBP，最大 5MB</span>
            </div>
            <div v-else class="upload-preview">
              <img :src="uploadPreview" alt="预览" />
              <button class="btn-rechoose" @click.stop="resetUploadState">重新选择</button>
            </div>
          </div>
          
          <!-- 图片类型选择 -->
          <div class="form-item" style="margin-top: 16px;">
            <label style="display: block; margin-bottom: 8px; font-size: 14px;">图片类型：</label>
            <select v-model="uploadImageType" class="form-select" style="width: 100%; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px;">
              <option value="">请选择</option>
              <option value="avatar">头像</option>
              <option value="background">背景图</option>
              <option value="dish">菜品</option>
              <option value="daka_dish_image">打卡</option>
            </select>
          </div>
          
          <!-- 上传进度 -->
          <div v-if="uploading" class="progress-bar-container" style="margin-top: 16px;">
            <div class="progress-bar" :style="{ width: uploadProgress + '%' }"></div>
            <span class="progress-text">{{ uploadProgress }}%</span>
          </div>
        </div>
        
        <div class="modal-footer">
          <button class="btn-default" @click="closeUploadModal">取消</button>
          <button class="btn-primary" @click="confirmUpload" :disabled="!uploadFile || uploading">
            {{ uploading ? '上传中...' : '确认上传' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import {
  getImageList,
  deleteImageRecord,
  clearDakaImage,
  deleteAllDeletedImages,
} from "@/api/houtai/dishes.js";
import { deleteuserpi } from "@/api/houtai/index.js";

export default {
  name: "userDeshespic",
  data() {
    return {
      loading: false,
      imageList: [],
      total: 0,
      page: 1,
      pageSize: 50,
      filters: {
        status: "",
        image_type: "",
        is_deleted: "",
        keyword: "",
      },
      copySuccess: false,
      copyMessage: "",
      deleteConfirmVisible: false,
      currentDeleteItem: null,
       // 添加这两个变量
    uploadModalVisible: false,  // 控制上传弹框显示
    uploadFile: null,           // 存储选择的文件
    uploadPreview: "",          // 预览图片URL
    uploadProgress: 0,          // 上传进度
    uploading: false,            // 是否上传中
    uploadImageType: ""  // 添加这个
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
  },
  methods: {
      // 打开上传弹框
  openModal() {
    this.uploadModalVisible = true;
    this.resetUploadState();
  },
  
  // 关闭上传弹框
  closeUploadModal() {
    this.uploadModalVisible = false;
    this.resetUploadState();
  },
  
  // 重置上传状态
  resetUploadState() {
    this.uploadFile = null;
    if (this.uploadPreview) {
      URL.revokeObjectURL(this.uploadPreview);
    }
    this.uploadPreview = "";
    this.uploadProgress = 0;
    this.uploading = false;
  },
  
  // 触发文件选择
  triggerFileInput() {
    this.$refs.fileInput.click();
  },
  
  // 处理文件选择
  handleFileChange(event) {
    const file = event.target.files[0];
    if (!file) return;
    
    // 校验图片格式
    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      alert("只支持 JPG、PNG、GIF、WEBP 格式");
      return;
    }
    
    // 校验大小（5MB）
    if (file.size > 5 * 1024 * 1024) {
      alert("图片大小不能超过 5MB");
      return;
    }
    
    this.uploadFile = file;
    
    // 生成预览
    const reader = new FileReader();
    reader.onload = (e) => {
      this.uploadPreview = e.target.result;
    };
    reader.readAsDataURL(file);
  },
  
  // 确认上传
  async confirmUpload() {
    if (!this.uploadFile) {
      alert("请先选择图片");
      return;
    }
    
    // 获取选择的图片类型
    const imageType = this.uploadImageType;
    if (!imageType) {
      alert("请选择图片类型");
      return;
    }
    
    this.uploading = true;
    this.uploadProgress = 0;
    
    // 重命名文件
    const typeMap = {
      "image/jpeg": "jpg",
      "image/png": "png",
      "image/gif": "gif",
      "image/webp": "webp",
    };
    const extension = typeMap[this.uploadFile.type] || "jpg";
    const newFileName = `${Date.now()}.${extension}`;
    const renamedFile = new File([this.uploadFile], newFileName, { type: this.uploadFile.type });
    
    const formData = new FormData();
    formData.append("file", renamedFile);
    formData.append("image_type", imageType);  // 传递图片类型
    
    // 模拟进度
    const interval = setInterval(() => {
      if (this.uploadProgress < 90) {
        this.uploadProgress += 10;
      }
    }, 100);
    
    try {
      // 调用上传接口（根据您的实际接口地址修改）
      const res = await request.post("/pic/Dishespic", formData);
      clearInterval(interval);
      this.uploadProgress = 100;
      
      if (res.success) {
        alert("上传成功！");
        this.closeUploadModal();
        this.loadImageList();  // 刷新列表
      } else {
        alert(res.message || "上传失败");
      }
    } catch (error) {
      clearInterval(interval);
      console.error("上传失败:", error);
      alert("上传失败，请重试");
    } finally {
      this.uploading = false;
    }
  },
    // 清空所有已删除的数据
    async handleDeleteAllDeleted() {
      // 确认弹窗
      const confirmed = confirm(
        "⚠️ 此操作将永久删除所有已标记为删除的图片记录，不可恢复！确定要继续吗？"
      );
      if (!confirmed) return;

      this.loading = true;
      try {
        const res = await deleteAllDeletedImages();
        if (res.code === 200) {
          this.showCopyMessage(res.msg);
          // 刷新列表
          await this.loadImageList();
        } else {
          alert(res.msg || "删除失败");
        }
      } catch (error) {
        console.error("清空失败:", error);
        alert("清空失败，请重试");
      } finally {
        this.loading = false;
      }
    },
    // 格式化时间
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    viewOriginalImage(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    async loadImageList() {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          ...this.filters,
        };
        Object.keys(params).forEach((key) => {
          if (
            params[key] === "" ||
            params[key] === null ||
            params[key] === undefined
          ) {
            delete params[key];
          }
        });

        const res = await getImageList(params);

        if (res && res.code === 200) {
          this.imageList = res.data?.list || [];
          this.total = res.data?.total || 0;
        } else {
          alert(res?.msg || "加载失败");
          this.imageList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("加载图片列表失败:", error);
        alert("加载失败，请重试");
        this.imageList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    async copyImageUrl(url) {
      if (!url) {
        this.showCopyMessage("链接无效");
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        this.showCopyMessage("复制成功！");
      } catch (err) {
        const textarea = document.createElement("textarea");
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.showCopyMessage("复制成功！");
      }
    },

    showCopyMessage(msg) {
      this.copyMessage = msg;
      this.copySuccess = true;
      setTimeout(() => {
        this.copySuccess = false;
        this.copyMessage = "";
      }, 2000);
    },

    handleDeleteImage(item) {
      this.currentDeleteItem = item;
      this.deleteConfirmVisible = true;
    },

    closeDeleteConfirm() {
      this.deleteConfirmVisible = false;
      this.currentDeleteItem = null;
    },

    async confirmDelete() {
      if (!this.currentDeleteItem) return;

      const item = this.currentDeleteItem;
      this.loading = true;

      try {
        // 1. 删除 OSS 图片
        await deleteuserpi({ fileUrl: item.image_url });

        // 2. 删除数据库记录（使用导入的函数）
        await deleteImageRecord({ id: item.id });

        // 3. 如果是打卡图片，清除打卡记录中的图片
        if (item.image_type === "daka_dish_image" || item.image_type === "daka") {
          await clearDakaImage({ imageUrl: item.image_url });
        }

        this.showCopyMessage("删除成功！");
        await this.loadImageList();
      } catch (error) {
        console.error("删除失败:", error);
        alert("删除失败：" + (error.message || "请重试"));
      } finally {
        this.loading = false;
        this.closeDeleteConfirm();
      }
    },

    handleSearch() {
      this.page = 1;
      this.loadImageList();
    },

    handleReset() {
      this.filters = {
        status: "",
        image_type: "",
        is_deleted: "",
        keyword: "",
      };
      this.page = 1;
      this.loadImageList();
    },

    handleSizeChange() {
      this.page = 1;
      this.loadImageList();
    },

    handleCurrentChange(page) {
      this.page = page;
      this.loadImageList();
    },

    getTypeClass(type) {
      const map = {
        avatar: "type-avatar",
        background: "type-background",
        dish: "type-dish",
        daka_dish_image: "type-daka",
      };
      return map[type] || "";
    },

    getTypeName(type) {
      const map = {
        avatar: "头像",
        background: "背景图",
        dish: "菜品",
        daka_dish_image: "打卡",
      };
      return map[type] || type;
    },

    getStatusClass(status) {
      const map = {
        pending: "status-pending",
        safe: "status-safe",
        violation: "status-violation",
        review: "status-review",
        failed: "status-failed",
      };
      return map[status] || "";
    },

    getStatusName(status) {
      const map = {
        pending: "待检测",
        safe: "安全",
        violation: "违规",
        review: "疑似",
        failed: "失败",
      };
      return map[status] || status;
    },

    getLabelName(label) {
      const map = {
        20001: "色情内容",
        20002: "时政敏感",
        20003: "暴恐违禁",
        20004: "违法违规",
        20006: "广告导流",
      };
      return map[label] || "未知";
    },
  },
  mounted() {
    this.loadImageList();
  },
};
</script>

<style scoped>
/* 上传区域样式 */
.upload-area {
  cursor: pointer;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  transition: all 0.2s;
}

.upload-area:hover {
  border-color: #409eff;
  background: #f5f7fa;
}

.upload-placeholder {
  padding: 40px;
  text-align: center;
}

.upload-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 8px;
}

.upload-hint {
  font-size: 12px;
  color: #909399;
}

.upload-preview {
  position: relative;
  text-align: center;
  padding: 20px;
}

.upload-preview img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
}

.btn-rechoose {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.progress-bar-container {
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  height: 24px;
}

.progress-bar {
  background: #409eff;
  height: 100%;
  transition: width 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
}

.form-select:focus {
  outline: none;
  border-color: #409eff;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.alldel{
 flex: 1;
 text-align: right;
}
.page-header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left h2 {
  font-size: 20px;
  color: #303133;
  margin: 0;
}

.header-right {
  display: flex;
  gap: 12px;
}
.image-management {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  font-size: 20px;
  color: #303133;
  margin: 0;
}

.filter-bar {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-item label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.filter-item select,
.filter-item input {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  background: #fff;
}

.filter-item select:focus,
.filter-item input:focus {
  border-color: #409eff;
}

.filter-actions {
  display: flex;
  gap: 10px;
}

.btn-primary,
.btn-default,
.btn-danger {
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: all 0.3s;
}

.btn-primary {
  background: #409eff;
  color: #fff;
}

.btn-primary:hover {
  background: #66b1ff;
}

.btn-default {
  background: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.btn-default:hover {
  background: #f5f7fa;
}

.btn-danger {
  background: #f56c6c;
  color: #fff;
}

.btn-danger:hover {
  background: #ff4d4f;
}

.delete-btn {
  padding: 4px 12px;
  background: #f56c6c;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 8px;
  transition: background 0.2s;
}

.delete-btn:hover {
  background: #ff4d4f;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table th,
.data-table td {
  padding: 4px 16px;
  text-align: left;
  border-bottom: 1px solid #ebeef5;
}

.data-table th {
  background: #fafafa;
  color: #909399;
  font-weight: 500;
}

.data-table tbody tr:hover {
  background: #f5f7fa;
}

.image-cell {
  width: 50px;
  height: 50px;
}

.thumbnail {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
  transition: opacity 0.2s;
}

.thumbnail:hover {
  opacity: 0.8;
}

.type-badge,
.status-badge,
.delete-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.type-avatar {
  background: #e6f7ff;
  color: #1890ff;
}
.type-background {
  background: #f6ffed;
  color: #52c41a;
}
.type-dish {
  background: #fff7e6;
  color: #fa8c16;
}
.type-daka {
  background: #f9f0ff;
  color: #722ed1;
}

.status-pending {
  background: #f4f4f5;
  color: #909399;
}
.status-safe {
  background: #f6ffed;
  color: #52c41a;
}
.status-violation {
  background: #fff2f0;
  color: #ff4d4f;
}
.status-review {
  background: #fff7e6;
  color: #fa8c16;
}
.status-failed {
  background: #fff2f0;
  color: #ff4d4f;
}

.delete-badge.normal {
  background: #f6ffed;
  color: #52c41a;
}
.delete-badge.deleted {
  background: #fff2f0;
  color: #ff4d4f;
}

.openid-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: monospace;
  font-size: 12px;
}

.label-text {
  color: #fa8c16;
}
.type-daka {
  background: #f9f0ff;
  color: #722ed1;
}
.copy-link-btn {
  padding: 4px 12px;
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.2s;
}

.copy-link-btn:hover {
  background: #66b1ff;
}

.empty-row {
  text-align: center;
  color: #909399;
  padding: 40px;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}

.pagination-info select {
  padding: 4px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.pagination-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-buttons button {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.pagination-buttons button:hover:not(:disabled) {
  background: #409eff;
}

.pagination-buttons button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.page-info {
  padding: 0 12px;
  font-size: 14px;
  color: #606266;
}

.copy-toast {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 2000;
  animation: fadeInOut 2s ease;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  15% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  85% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.modal-container {
  background: #fff;
  border-radius: 8px;
  width: 450px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #909399;
}

.modal-header .close-btn:hover {
  color: #409eff;
}

.modal-body {
  padding: 20px;
}

.delete-warning {
  color: #e6a23c;
  font-weight: bold;
  margin-top: 12px;
  margin-bottom: 8px;
}

.delete-list {
  margin: 0 0 12px 20px;
  padding: 0;
  color: #606266;
  font-size: 14px;
}

.delete-list li {
  margin: 4px 0;
}

.delete-confirm-text {
  color: #f56c6c;
  font-weight: bold;
  margin-top: 12px;
}

.modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
